import { IUserMilestone } from "@faire/web-api--source/indigofair/data/IUserMilestone";
import React from "react";

import { useSilenceWithMilestone } from "./useSilenceWithMilestone";

interface IProps {
  milestone: keyof typeof IUserMilestone.RetailerMilestone;
  maxViewCount: number;
  children: React.ReactNode;
}

export const SilenceChildComponent: React.FC<IProps> = ({
  milestone,
  maxViewCount,
  children,
}) => {
  const { isSilenced } = useSilenceWithMilestone(milestone, maxViewCount);

  if (isSilenced) {
    return null;
  }

  return <>{children}</>;
};
